<template>
  <div class="soundWaves" @touchstart.prevent  @touchstart="data.startAnimation" @touchend.prevent="data.stopAnimation">
    <div v-if="data.num === 1 " @touchend.prevent="data.stopAnimation" class="yuyin1" />
    <div v-if="data.num === 2 " @touchend.prevent="data.stopAnimation" class="yuyin2" />
    <div v-if="data.num === 3 " @touchend.prevent="data.stopAnimation" class="yuyin3" />
    <div v-if="data.num === 4 " @touchend.prevent="data.stopAnimation" class="yuyin4" />
    <div v-if="data.num === 5 " @touchend.prevent="data.stopAnimation" class="yuyin5" />
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
} from "vue";
import { useCounterStore } from '@/store'
import { useRoute, useRouter } from "vue-router";
import RecorderManager from "@/ulits/index";
import CryptoJS from "crypto-js";
import microphoneIcon from '@/assets/microphoneIcon.png'
import red from '@/assets/red.png'
const store = useCounterStore();
const route = useRoute();
const router = useRouter();
const data = reactive({});
data.numDownInterval = null
data.voiceTiming = null
data.num = 1
data.soadp = true;
data.recorder = new RecorderManager("");
data.resultText = "";
data.resultTextTemp = "";
data.countdownInterval = null;
data.iatWS = null;  
navigator.mediaDevices.getUserMedia({ audio: true })
const emit = defineEmits(['changeStr','start','end'])
data.openWxRecord = () =>{
  wx.startRecord({
    success: (res)=>{
      console.log(7777);
      let num = 0
      emit('start',1)
      data.voiceTiming = setInterval(()=>{
        num = num + 1
        emit('start',num)
        if (num >= 60) {
          emit('end')
          clearInterval(data.voiceTiming)
          clearInterval(data.numDownInterval)
          wx.stopRecord({
            success: (seodc) => {
              wx.translateVoice({
                localId: seodc.localId, // 需要识别的音频的本地Id，由录音相关接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function (res) {
                  if (res.translateResult !== 'undefined') {
                    emit('changeStr',res.translateResult)
                  }
                },
              });
            },
          });
        }
      },1000)
      data.numDownInterval = setInterval(()=>{
        data.num = data.num + 1
        if (data.num >= 5 ) {
          data.num = 1
        }
      },100)
    }
  })
}
data.startAnimation = () =>{
  console.log(store.WxFlage);
   if (store.WxFlage) {
    data.openWxRecord()
   } else {
    data.connectWebSocket()
   }


}

data.stopAnimation = () =>{
  clearInterval(data.numDownInterval)
   if (store.WxFlage) {
      clearInterval(data.voiceTiming)
      wx.stopRecord({
        success: (seodc) => {
          emit('end')
          wx.translateVoice({
            localId: seodc.localId, // 需要识别的音频的本地Id，由录音相关接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
              if (res.translateResult !== 'undefined') {
                emit('changeStr',res.translateResult)
              }
            },
          });
        },
      });
   } else {
    data.recorder.stop();
    clearInterval(data.numDownInterval)
    clearInterval(data.countdownInterval);
    emit('end')
    data.countdownInterval = null
    data.resultText = ''
    data.resultTextTemp = ''
   }
}

// 获取长链接
data.getWebSocketUrl = (e) => {
  // 请求地址根据语种不同变化
  let url = "wss://iat-api.xfyun.cn/v2/iat";
  let host = "iat-api.xfyun.cn";
  // let apiKey = "038cd396594c5f5b22e3d7abbd8052c1";
  // let apiSecret = "NTNkZmVjNGE0YjBmNWFmZWQxYmI1NWJi";
  let apiKey = "1113f558d1385c0ab9ae682490ae4701";
  let apiSecret = '159bd4175b3610ddd31cdde2e90fef2a'
  let date = new Date().toGMTString();
  let algorithm = "hmac-sha256";
  let headers = "host date request-line";
  let signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
  let signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
  let signature = CryptoJS.enc.Base64.stringify(signatureSha);
  let authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
  let authorization = btoa(authorizationOrigin);
  url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
  return url;
};

// base64 加密
data.toBase64 = (buffer) => {
  let binary = "";
  let bytes = new Uint8Array(buffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

// 开始录音
data.connectWebSocket = () => {
  const websocketUrl = data.getWebSocketUrl();
  if ("WebSocket" in window) {
    data.iatWS = new WebSocket(websocketUrl);
  } else if ("MozWebSocket" in window) {
    data.iatWS = new MozWebSocket(websocketUrl);
  } else {
    alert("浏览器不支持WebSocket");
    return;
  }
  data.iatWS.onopen = (e) => {
    data.recorder.start({
      sampleRate: 16000,
      frameSize: 1280,
    });
    // 开始录音
    let params = {
      common: {
        app_id: "5e970a17",
      },
      business: {
        language: "zh_cn",
        domain: "iat",
        accent: "mandarin",
        vad_eos: 50000,
        dwa: "wpgs",
      },
      data: {
        status: 0,
        format: "audio/L16;rate=16000",
        encoding: "raw",
      },
    };
    data.iatWS.send(JSON.stringify(params));
  };
  data.iatWS.onmessage = (e) => {
    data.renderResult(e.data);
  };
  data.iatWS.onerror = (e) => {
    data.recorder.stop();
  };
  data.iatWS.onclose = (e) => {
    data.recorder.stop();
  };
  data.countdown();
  data.recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
    if (data.iatWS.readyState === data.iatWS.OPEN) {
      data.iatWS.send(
        JSON.stringify({
          data: {
            status: isLastFrame ? 2 : 1,
            format: "audio/L16;rate=16000",
            encoding: "raw",
            audio: data.toBase64(frameBuffer),
          },
        })
      );
      if (!frameBuffer) {
        data.recorder.stop();
      }
    }
  };
};

// 录音过程
data.countdown = (e) => {
  let seconds = 0;
  data.countdownInterval = setInterval(() => {
    seconds = seconds + 1;
    emit('start',seconds)
    if (seconds >= 60) {
      emit('end')
      clearInterval(data.countdownInterval);
      clearInterval(data.numDownInterval)
      data.countdownInterval = null
      data.recorder.stop();
      data.soadp = true
      data.resultText = ''
      data.resultTextTemp = ''
    }
  }, 1000);
  data.numDownInterval = setInterval(()=>{
    data.num = data.num + 1
    if (data.num >= 5 ) {
      data.num = 1
    }
  },100)
}

// 录音结束
data.renderResult = (resultData) => {
  // 识别结束
  let jsonData = JSON.parse(resultData);
  if (jsonData.data && jsonData.data.result) {
    let res = jsonData.data.result;
    let str = "";
    let ws = res.ws;
    for (let i = 0; i < ws.length; i++) {
      str = str + ws[i].cw[0].w;
    }
    if (res.pgs) {
      if (res.pgs === "apd") {
        data.resultText = data.resultTextTemp;
      }
      data.resultTextTemp = data.resultText + str;
    } else {
      data.resultText = data.resultText + str;
    }
    emit('changeStr',data.resultText)
  }
  if (jsonData.code === 0 && jsonData.data.status === 2) {
    data.iatWS.close()
    data.soadp = true
  }
  if (jsonData.code !== 0) {
    data.iatWS.close()
    data.soadp = true
  }
}

onBeforeMount(() => {});
onMounted(() => {
  wx.startRecord()
  wx.stopRecord()
});
watchEffect(() => {});
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.soundWaves{
  margin: auto;
  margin-top: 24px;
  width: 168px;
  height: 168px;
  background: url('~@/assets/yuyinbackground.png') no-repeat;
  background-size: 100%;
  img{
    width: 160px;
    height: 168px;
  }
}
.yuyin1{
  width: 160px;
  height: 168px;
  background:url('~@/assets/yuyin1.png') no-repeat;
  background-size: 100%;
}
.yuyin2{
  width: 160px;
  height: 168px;
  background:url('~@/assets/yuyin2.png') no-repeat;
  background-size: 100%;
}
.yuyin3{
  width: 160px;
  height: 168px;
  background:url('~@/assets/yuyin3.png') no-repeat;
  background-size: 100%;
}
.yuyin4{
  width: 160px;
  height: 168px;
  background:url('~@/assets/yuyin4.png') no-repeat;
  background-size: 100%;
}
.yuyin5{
  width: 160px;
  height: 168px;
  background:url('~@/assets/yuyin5.png') no-repeat;
  background-size: 100%;
}
</style>
